// extracted by mini-css-extract-plugin
module.exports = {"root":"EnvironmentStatusBar_root__m1G4Q"};